export interface I18nMessages {
    [key: string]: string | I18nMessages;
}

export interface I18nTranslateFunction {
    (key: string): string;
}

export interface I18nProviderFunction {
    (locale: string): Promise<I18nMessages>;
}

function resolvePath(
    path: string,
    messages: I18nMessages,
    separator = "."
): unknown {
    return path
        .split(separator)
        .reduce(
            (prev, curr) =>
                prev === null || prev === undefined ? undefined : prev[curr],
            messages
        );
}

export function getI18nMessage(key: string, messages: I18nMessages): string {
    if (typeof messages !== "object") {
        return key;
    }
    const value = resolvePath(key, messages);
    return typeof value === "string" ? value : key;
}
